import React, { JSXElementConstructor, ReactElement, ReactNodeArray, ReactPortal } from "react";
import { Segment, List, DropdownItemProps, Image, Grid, Divider, Header, Icon, Button, Form, Accordion, Input, Modal, Table, Dropdown, DropdownProps } from "semantic-ui-react";
import UserRepository from "../../../../../common/repository/UserRepository";
import Result from "../../../../../common/repository/Result";
import User from "../../../../../models/User";
import InvestigatorProfileCard from "../InvestigatorProfileCard";
import CaseRepository from "../../../../../common/repository/CaseRepository";
import Case from "../../../../../models/Case";
import { toast } from "../../../../common/Toast";
import constants from "../../../../../common/constants";
import RequirePermission from "../../../../base/RequirePermission";
import permissions from "../../../../../common/permissions";
import { TagsInput } from "react-tag-input-component";
import config from "../../../../../common/repository/config";
import LocalStorage from "../../../../../lib/LocalStorage";
import FilesPopup from "../../../case/CaseViewPage/FilesPopup";
import ReactDOM from "react-dom";
import URLResource from "../../../../../models/URLResource";
import States from "../../../../../models/States";
import StateDistrictRepository from "../../../../../common/repository/StatesDistrictsRepository";
const investigationSpecifications = ["Cashless", "Detailed Investigation", "Insured Part", "Hospital Part", "Vicinity Check", "Document Verification",];
interface ActionAllocationProps {
  model: Case;
  updateModel(c: Case): void;
}
interface ActionAllocationState {
  roles: { id: string; title: string }[];
  role: string;
  inputValue: string;
  keypadVisible: boolean;
  modalOpen: boolean;
  rolesInCase: boolean;
  selectedRoleInCase: string | null;
  apiResponseModalOpen: any,
  apiResponseData: any,
  callItemModalOpen: boolean;
  callItemNumber: string;
  name: string;
  userRole: string;
  disableReportWriting: boolean;
  invoiceReceiptsVisible: boolean;
  stakeholder_role: { key: string, text: string, value: string }[]
  options: { key: string; text: string; value: string }[];
  contactNumber: string;
  handleConfirmCall: string;
  isCalling: boolean;
  isMinimized: boolean;
  confirmModalOpen: boolean;
  selectedContactNumber: string | null;
  active: boolean;
  disable_invoive_btn: boolean;
  loading: boolean;
  loadingCaseAllocateData: boolean;
  loadingInvestigators: boolean;
  investigatorOptions: DropdownItemProps[];
  investigators: User[];
  alloc_selectedInvestigator: string; //id
  alloc_selectedInvestigationSpecifications: string[];
  alloc_otherInvestigationSpecifications: string;
  alloc_selection: { investigator: User; specs: string[]; serviceType: string[], required_doc: string[] }[];
  servicesType: any[]
  services: string[]
  selectedServices: string[]
  originalRequiredDocuments: string[]
  invoiceUrl: URLResource[];
  required_documents: string[]
  selectedDocuments: string[]
  customDocInput: string
  loadingStates: boolean;
  selected_state: string;
  districtOptions: DropdownItemProps[];
  selected_district: string;
  stateOptions: DropdownItemProps[];
  loadingDistrict: boolean;
  states: States[];
  district: string[];
  isAccordionOpen: boolean,
  selectedFile: null,
  approvedExpenseModalOpen: boolean,
  expenseTitle: string,
  expenseFiles: any,
  // loading: false,
  x: number;
  y: number;
  contact: {
    [x: string]: string | number | boolean | {} | ReactElement<any, string | JSXElementConstructor<any>> | ReactNodeArray | ReactPortal | null | undefined; name: string; role: string; contactNumber: string
  }[];
}
class ActionAllocation extends React.Component<
  ActionAllocationProps,
  ActionAllocationState
> {

  private usersRepo = new UserRepository();
  private caseRepo = new CaseRepository();
  private stateDistrictRepo = new StateDistrictRepository();
  constructor(props: ActionAllocationProps) {
    super(props);
    this.state = {
      options: [],
      inputValue: '',
      disable_invoive_btn: true,
      keypadVisible: false,
      rolesInCase: false,
      selectedRoleInCase: null,
      callItemNumber: "",
      apiResponseModalOpen: false,
      callItemModalOpen: false,
      apiResponseData: null,
      isCalling: false,
      isMinimized: false,
      active: false,
      loading: false,
      stakeholder_role: [],
      loadingInvestigators: false,
      loadingCaseAllocateData: false,
      investigatorOptions: [],
      investigators: [],
      alloc_selectedInvestigator: "",
      alloc_selectedInvestigationSpecifications: [],
      alloc_otherInvestigationSpecifications: "",
      alloc_selection: [],
      servicesType: props.model.getType().getServices(),
      services: [],
      selectedServices: [],
      originalRequiredDocuments: props.model.getType().getRequiredDocumne() || [],
      required_documents: props.model.getType().getRequiredDocumne() || [],
      selectedDocuments: [],
      customDocInput: "",
      modalOpen: false,
      name: "",
      role: "",
      userRole: "",
      disableReportWriting: true,
      roles: [],
      contactNumber: "",
      contact: [],
      confirmModalOpen: false,
      selectedContactNumber: null,
      handleConfirmCall: "",
      invoiceReceiptsVisible: false,
      invoiceUrl: [],
      x: 0,
      y: 0,
      loadingStates: false,
      selected_state: "",
      districtOptions: [],
      selected_district: "",
      stateOptions: [],
      loadingDistrict: false,
      district: [],
      states: [],
      isAccordionOpen: false,
      selectedFile: null,
      approvedExpenseModalOpen: false,
      expenseTitle: "",
      expenseFiles: null,

    };
  }
  componentDidMount() {
    this.getInvestigators();
    this.getState();
    this.getUser();
    this.fetchContacts();
    this.handleConfirmCall();
    this.fetchStakeholderRoles();
    this.fetchInvoiceDocument(this.props.model.getId());
    this.getAllocateCaseData();
  }

  private fetchStakeholderRoles = async () => {
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error('Authentication token is missing.');
        return;
      }
      const response = await fetch(`${config.apiBaseURL}/stakeHolderRole/listRole`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
      });
      if (response.ok) {
        const result = await response.json();
        if (Array.isArray(result.data.items)) {
          const roles = result.data.items;
          this.setState({
            stakeholder_role: roles.map((role: any) => ({
              key: role.name,
              text: role.name,
              value: role.name
            }))
          });
        } else {
          console.error('Failed to fetch user by token');
        }
      } else {
        throw new Error('Failed to fetch roles');
      }
    } catch (error) {
      console.error('An error occurred while fetching roles');
    }
  };
  async fetchInvoiceDocument(case_id: string) {
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      console.error("Authentication token is missing.");
      return;
    }
    try {
      const response = await fetch(`${config.apiBaseURL}/case/listInvoiceQc/${case_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });
      const data = await response.json();

      if (data.success && data.data) {
        const { items, message } = data.data;
        if (Array.isArray(items) && items.length > 0) {
          const flattenedItems = items.flat();
          this.setState((prevState) => ({
            ...prevState,
            invoiceUrl: flattenedItems,
            responseMessage: null,
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            responseMessage: message || "No invoice URL found.",
          }));
          toast.error(message || "No invoice URL found.");
        }
        this.setState({
          disable_invoive_btn: true,
        });
      } else {
        this.setState({
          disable_invoive_btn: true,
        });
      }
    } catch (error) {

      toast.error("Error occurred while fetching data");
    }
  }
  handleApproveExpernce = async (e: React.FormEvent) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { expenseTitle, expenseFiles } = this.state;
    const { model } = this.props;

    const caseId = model.getId();
    if (!expenseTitle) {
      toast.error("Please enter Enter  Approved Expense .");
      return;
    }

    if (!expenseFiles || expenseFiles.length === 0) {
      toast.error("Please add at least one Approved Expense Receipt.");
      return;
    }
    const formData = new FormData();
    formData.append("approvedExpense", expenseTitle);
    formData.append("caseId", caseId);
    for (let i = 0; i < expenseFiles.length; i++) {
      formData.append("expenseReceipt", expenseFiles[i]);
    }
    const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
    if (!token) {
      console.error("Authentication token is missing.");
      return;
    }

    try {
      const response = await fetch(`${config.apiBaseURL}/case/addApprovedExpense`, {
        method: "POST",
        headers: {
          "x-access-token": token,
        },
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Approved Expense Added Successfully")
        this.setState({
          approvedExpenseModalOpen: false,
          expenseTitle: "",
          expenseFiles: null,
        });
      } else {
        toast.error(result.message || "Failed to upload expense.");
      }

    } catch (error) {
      console.error("Upload failed:", error);
      alert("An error occurred while uploading.");
    } finally {
      this.setState({ loading: false });
    }
  };

  private getUser = async () => {
    let result = await this.usersRepo.getUserByToken();
    if (result instanceof Result.Success) {
      this.setState({ userRole: result.data.getRole().getTitle() });
    }
  }

  private getState = () => {
    this.setState({ loadingStates: true }, async () => {
      let result = await this.stateDistrictRepo.getStates();
      if (result instanceof Result.Success) {
        const fetchedStates = result.data.items;
        const options = fetchedStates.map((it: any) => {
          return this.stateToDropDownOption(it);
        });

        this.setState({
          loadingStates: false,
          stateOptions: options.sort((a: any, b: any) => {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
          }),
          states: fetchedStates
        });
      } else {
        this.setState({ loadingStates: false }, () => {
          const message = "Could not load States";
          toast.error(message);
        });
      }
    });
  };

  private getDistrict = (stateName: string) => {
    this.setState({ loadingDistrict: true }, async () => {
      let result = await this.stateDistrictRepo.getDistricts({ state: stateName });
      if (result instanceof Result.Success) {
        const fetchedDistricts = result.data.items;
        const options = fetchedDistricts.map((it: string) => {
          return this.districtToDropDownOption(it);
        });
        this.setState({
          loadingDistrict: false,
          districtOptions: options.sort((a: any, b: any) => {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
          }),
          district: fetchedDistricts
        });

      } else {
        this.setState({ loadingDistrict: false }, () => {
          const message = "Could not load Districts";
          toast.error(message);
        });
      }
    });
  };

  private getInvestigators = (state?: string, district?: string) => {
    this.setState({ loadingInvestigators: true }, async () => {
      let result: any;
      if (state && district !== undefined) {
        result = await this.usersRepo.getUsersByRoleTitle({
          role: constants.roleTitle.investigator,
          location: {
            state: state,
            district: district,
          }
          // is_active: true,
        });
      } else {
        result = await this.usersRepo.getUsersByRoleTitle({
          role: constants.roleTitle.investigator
          // is_active: true,
        });
      }

      if (result instanceof Result.Success) {
        const investigators = result.data.items;
        const options = investigators.map((it: any) => {
          return this.investigatorToDropDownOption(it);
        });
        this.setState({
          loadingInvestigators: false,
          investigatorOptions: options,
          investigators,
        });
      } else {
        this.setState({ loadingInvestigators: false }, () => {
          const message = result.message || "Could not load Investigators";
          toast.error(message);
        });
      }
    });
  };
  private allocateInvesitgators = () => {
    this.setState({ loading: true }, async () => {
      const { model, updateModel } = this.props;
      const allocations = this.state.alloc_selection.map((it) => {
        return {
          investigator_id: it.investigator.getId(),
          specifications: it.specs,
          services: it.serviceType,
          required_documents: it.required_doc
        };
      });

      const result = await this.caseRepo.allocateInvestigators({

        case_id: model.getId(),
        allocations,
      });

      if (result instanceof Result.Success) {
        const c = result.data;
        this.setState(
          {
            loading: false,
            investigatorOptions: [],
            investigators: [],
            alloc_selectedInvestigator: "",
            selected_state: "",
            selected_district: "",
            alloc_selectedInvestigationSpecifications: [],
            alloc_otherInvestigationSpecifications: "",
            alloc_selection: [],
          },
          () => {
            updateModel(c);
            toast.success("Case Allocated Successfully");
            this.getInvestigators();
          }
        );
      } else {
        const message = result.message || "Something went wrong";
        this.setState({ loading: false }, () => {
          toast.error(message);
        });
      }
    });
  };

  private getAllocateCaseData = () => {
    this.setState({ loadingCaseAllocateData: true }, async () => {
      const { model } = this.props;
      let result = await this.caseRepo.getAllocatedInvestigators({ case_id: model.getId() });
      if (result instanceof Result.Success) {
        const fetchedAllocatedCaseData = result.data.items;
        const pendingFinishAllocate = fetchedAllocatedCaseData.filter((i) => i.getActive() === true);
        console.log(pendingFinishAllocate, "Pending")
        if (!pendingFinishAllocate.length) this.setState({ disableReportWriting: false });
      } else {
        this.setState({ loadingDistrict: false }, () => {
          const message = "Could not load Districts";
          toast.error(message);
        });
      }
    });
  };

  private handleReportWriting = () => {
    this.setState({ loading: true }, async () => {
      const { model } = this.props;
      const result = await this.caseRepo.pushReportWriting({ case_id: model.getId(), case_type: model.getType()?.getId(), claim_number: model.getClaimNumber(), case_category: model.getCategory().getCode() });
      if (result instanceof Result.Success) {
        this.setState({ loading: false });
        toast.success("Case Pushed for Report Writing");
      } else {
        this.setState({ loading: false });
        toast.error(result.message || "Unable to push the case for report writing");
      }
    });
  }

  handleService = (e: any) => {
    const { value, checked } = e.target
    if (checked) {
      this.setState({ services: [...this.state.services, value] })
    } else {
      this.setState({ services: this.state.services.filter((e) => e !== value) })
    }
  }
  private static SERVICE_DOCUMENT_MAP: { [key: string]: string } = {
    "INSURED INFORMATION": "INSURED STATEMENT",
    "INSURED OCCUPATION INFORMATION": "WORK PLACE VISIT",
    "ATTENDANT INFORMATION": "ATTENDANT ID",
    "HOSPITAL INFRASTRUCTURE INFORMATION": "ICP",
    "TREATING DOCTOR INFORMATION": "DOCTOR STATEMENT",
    "PATHOLOGIST INFORMATION": "PATHOLOGIST STATEMENT",
  };

  handleCheckboxChange = (event: any) => {
    const { value, checked } = event.target;
    let newSelectedServices: string[];

    if (checked) {
      newSelectedServices = [...this.state.selectedServices, value];
    } else {
      newSelectedServices = this.state.selectedServices.filter((s) => s !== value);
    }

    // Build available documents:
    // 1. Always include originalRequiredDocuments (from client/case type)
    // 2. Add service-mapped docs for selected services
    // 3. Keep manually added docs
    const originalDocs = this.state.originalRequiredDocuments || [];
    const mappedDocs = newSelectedServices
      .map((service) => ActionAllocation.SERVICE_DOCUMENT_MAP[service])
      .filter((doc) => doc !== undefined);

    const docSet = new Set([...originalDocs, ...mappedDocs]);
    // Keep manually added docs (not in mapped values and not in original docs)
    const allMappedValues = Object.values(ActionAllocation.SERVICE_DOCUMENT_MAP);
    const manualDocs = this.state.required_documents.filter(
      (doc) => !allMappedValues.includes(doc) && !originalDocs.includes(doc)
    );
    manualDocs.forEach((doc) => docSet.add(doc));
    const newRequiredDocs = Array.from(docSet);

    // Auto-select newly mapped doc, keep existing selections
    const newSelectedDocuments = [...this.state.selectedDocuments];
    if (checked) {
      const mappedDoc = ActionAllocation.SERVICE_DOCUMENT_MAP[value];
      if (mappedDoc && !newSelectedDocuments.includes(mappedDoc)) {
        newSelectedDocuments.push(mappedDoc);
      }
    } else {
      // When unchecking a service, remove only its mapped doc from selected
      const unmappedDoc = ActionAllocation.SERVICE_DOCUMENT_MAP[value];
      if (unmappedDoc) {
        const idx = newSelectedDocuments.indexOf(unmappedDoc);
        if (idx !== -1) newSelectedDocuments.splice(idx, 1);
      }
    }

    // Remove any selectedDocuments that are no longer in available list
    const filteredSelected = newSelectedDocuments.filter((doc) => newRequiredDocs.includes(doc));

    this.setState({
      selectedServices: newSelectedServices,
      services: newSelectedServices,
      required_documents: newRequiredDocs,
      selectedDocuments: filteredSelected,
    });
  };

  handleDocumentCheckboxChange = (event: any) => {
    const { value, checked } = event.target;

    let newSelectedDocuments = [...this.state.selectedDocuments];
    let newSelectedServices = [...this.state.selectedServices];

    if (checked) {
      newSelectedDocuments.push(value);
    } else {
      // Remove document
      newSelectedDocuments = newSelectedDocuments.filter((d) => d !== value);

      // 🔥 Find if this document is mapped to any service
      const serviceToRemove = Object.keys(ActionAllocation.SERVICE_DOCUMENT_MAP)
        .find(
          (service) =>
            ActionAllocation.SERVICE_DOCUMENT_MAP[service] === value
        );

      // 🔥 If mapped → remove that service
      if (serviceToRemove) {
        newSelectedServices = newSelectedServices.filter(
          (s) => s !== serviceToRemove
        );
      }
    }

    // 🔁 Rebuild required_documents (same logic as handleCheckboxChange)

    const originalDocs = this.state.originalRequiredDocuments || [];

    const mappedDocs = newSelectedServices
      .map((service) => ActionAllocation.SERVICE_DOCUMENT_MAP[service])
      .filter((doc) => doc !== undefined);

    const docSet = new Set([...originalDocs, ...mappedDocs]);

    const allMappedValues = Object.values(ActionAllocation.SERVICE_DOCUMENT_MAP);

    const manualDocs = this.state.required_documents.filter(
      (doc) =>
        !allMappedValues.includes(doc) && !originalDocs.includes(doc)
    );

    manualDocs.forEach((doc) => docSet.add(doc));

    const newRequiredDocs = Array.from(docSet);

    // Remove invalid selected docs
    const filteredSelected = newSelectedDocuments.filter((doc) =>
      newRequiredDocs.includes(doc)
    );

    this.setState({
      selectedDocuments: filteredSelected,
      selectedServices: newSelectedServices,
      services: newSelectedServices,
      required_documents: newRequiredDocs,
    });
  };

  // handleDocumentCheckboxChange = (event: any) => {
  //   const { value, checked } = event.target;
  //   if (checked) {
  //     this.setState({ selectedDocuments: [...this.state.selectedDocuments, value] });
  //   } else {
  //     this.setState({ selectedDocuments: this.state.selectedDocuments.filter((d) => d !== value) });
  //   }
  // };

  handleAddCustomDocument = () => {
    const doc = this.state.customDocInput.trim();
    if (!doc) return;
    if (this.state.required_documents.includes(doc)) {
      this.setState({ customDocInput: "" });
      return;
    }
    this.setState({
      required_documents: [...this.state.required_documents, doc],
      selectedDocuments: [...this.state.selectedDocuments, doc],
      customDocInput: "",
    });
  };
  handleOpenConfirmModal = (contactNumber: string) => {
    this.setState({ confirmModalOpen: true, selectedContactNumber: contactNumber });
  };
  handleCloseConfirmModal = () => {
    this.setState({ confirmModalOpen: false, selectedContactNumber: null });
  };

  handleEndCall = () => {
    this.setState({ isCalling: false, confirmModalOpen: false });
  };
  toggleMinimizeModal = () => {
    this.setState((prevState) => ({
      isMinimized: !prevState.isMinimized,
    }));
  };

  handleOpenModal = () => {
    this.setState({ modalOpen: true });
  };
  handleCloseModal = () => {
    this.setState({ modalOpen: false });
  };

  handleOpenApprovedExpenseModal = () => {
    this.setState({ approvedExpenseModalOpen: true });
  };

  handleCloseApprovedExpenseModal = () => {
    this.setState({ approvedExpenseModalOpen: false });
  };

  handleFileChange = (e: { target: { files: any[]; }; }) => {
    this.setState({ selectedFile: e.target.files[0] });
  };

  // handleApprovedExpenseSubmit = () => {
  //   console.log('Selected file:', this.state.selectedFile);
  //   // Optionally handle file upload here
  //   this.setState({ approvedExpenseModalOpen: false });
  // };


  handleAddContact = async () => {
    const { name, role, contactNumber } = this.state;
    const { model } = this.props;

    if (!name) {
      toast.error("Enter Stakeholder Name");
      return;
    }

    const contactNumberPattern = /^[0-9]{10}$/;
    if (!contactNumberPattern.test(contactNumber)) {
      toast.error("Contact Number must be exactly 10 digits.");
      return;
    }

    const payload = {
      name: name,
      roleInCase: role,
      caseId: model.getId(),
      contactNumber: contactNumber,
    };

    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error('Authentication token is missing.');
        return;
      }

      const response = await fetch(`${config.apiBaseURL}/case/addContact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success("Contact added successfully");
        console.log("Contact added successfully", data);
        await this.fetchContacts();
        this.setState({ modalOpen: false });
      } else {
        toast.error(data.message || "Failed to add contact");
        console.error("Failed to add contact:", data.message);
      }
    } catch (error) {
      console.error("Error adding contact:", error);
      toast.error("Something went wrong while adding contact");
    }
  };

  private fetchContacts = async () => {
    const { model } = this.props;
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) {
        console.error('Authentication token is missing.');
        return;
      }
      const caseId = model.getId();
      if (!caseId) {
        console.error('Case ID is missing.');
        return;
      }
      const response = await fetch(`${config.apiBaseURL}/case/listContact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-token': token,
        },
        body: JSON.stringify({ caseId }),
      });
      if (response.ok) {
        const data = await response.json();

        if (
          data.success &&
          data.data &&
          Array.isArray(data.data.items) &&
          data.data.items.length > 0
        ) {

          const contactArray = data.data.items[0]?.contact || [];
          this.setState({ contact: contactArray });
        } else {
          console.error("Unexpected data format:", data);

        }
      } else {
        const errorData = await response.json();
        console.error("Failed to fetch contacts:", errorData.message);

      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      toast.error("Error fetching contacts");
    }
  };
  handleContactNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const numericValue = value.replace(/\D/g, '');
    if (numericValue.length <= 10) {
      this.setState({ contactNumber: numericValue });
    }
  };
  // Conform Call API
  handleConfirmCall = async () => {
    const { selectedContactNumber } = this.state;
    const { model } = this.props;

    if (selectedContactNumber) {

      this.setState({ isCalling: true });

      try {
        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
        if (!token) {
          console.error('Authentication token is missing.');
          this.setState({ isCalling: false });
          return;
        }

        const caseId = model.getId();
        if (!caseId) {

          this.setState({ isCalling: false });
          return;
        }
        const response = await fetch(`${config.apiBaseURL}/case/makeCall`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'x-access-token': token,
          },
          body: JSON.stringify({
            caseId,
            contactNumber: selectedContactNumber,
          }),
        });
        if (response.ok) {
          const data = await response.json();
          toast.success("IVR Call In Process Please Answer the Call");
          console.log("API Response:", data);
          this.setState({
            apiResponseModalOpen: true,
            apiResponseData: data.data.items,

          });
          this.setState({ apiResponseModalOpen: true }, () => {
            this.setState({ callItemModalOpen: false });
          });

        } else {
          const errorData = await response.json();

        }
      } catch (error) {
        console.error("Error initiating call:", error);
      } finally {

        this.setState({ isCalling: false });
        this.handleCloseConfirmModal();
      }
    }
  };

  private handleDropdownChange = (e: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
    const value = data.value as string;
    console.log(value, "Selected role");
    this.setState({ role: value });
  };

  handleKeyPress = (value: string) => {
    this.setState((prevState) => ({
      inputValue: prevState.inputValue + value,
    }));
  };

  handleClear = () => {
    this.setState({ inputValue: '' });
  };

  handleSubmit = () => {

    this.setState({ inputValue: '', keypadVisible: false });
  };

  navigateIvrRecordings = (type: string) => {
    window.open(`/ivrrecordings/${this.props.model.getId()}`, '_self');
  };

  toggleKeypadVisibility = () => {
    this.setState((prevState) => ({
      keypadVisible: !prevState.keypadVisible,
    }));
  };


  render() {
    const { isCalling, isMinimized, apiResponseModalOpen, apiResponseData, callItemModalOpen, callItemNumber, roles, role, options, inputValue, keypadVisible } = this.state;
    if (this.state.isCalling) {
      return (
        <div>
          <Modal
            open={callItemModalOpen}
            onClose={() => this.setState({ callItemModalOpen: false })}
            size="small"
          >
            <Modal.Actions>
              <Button negative onClick={() => this.setState({ callItemModalOpen: false })}>
                Cancel
              </Button>
              <Button positive
              //  onClick={this.handleCallItemNumberSubmit}
              >
                Submit
              </Button>
            </Modal.Actions>
          </Modal>


          {isCalling && (
            <div
              style={{
                position: 'fixed',
                bottom: isMinimized ? 0 : '2%',
                right: '10%',
                zIndex: 1000,
                width: isMinimized ? '500px' : '400px',
              }}
            >
              <Segment raised>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  {isMinimized ? (
                    <Icon
                      name="window restore"
                      onClick={this.toggleMinimizeModal}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <>
                      <span>Calling Contact {this.state.selectedContactNumber} </span>
                      <Icon
                        name="window minimize"
                        onClick={this.toggleMinimizeModal}
                        style={{ cursor: 'pointer' }}
                      />
                    </>
                  )}
                </div>
                {!isMinimized && (
                  <>
                    <Segment >
                      <Icon name="phone" loading />
                      Calling contact...{this.state.selectedContactNumber}
                    </Segment>
                    <Button
                      basic
                      color="red"
                      onClick={this.handleEndCall}
                      style={{ marginTop: '10px' }}
                    >
                      End Call
                    </Button>
                  </>
                )}
              </Segment>
            </div>
          )}
        </div>
      );
    }
    const selectionList = this.state.alloc_selection.map((it, idx) => {
      const inv = it.investigator;
      const primary = User.getDistricts(inv.getPrimaryLocations()).join(", ");
      const secondary = User.getDistricts(inv.getSecondaryLocations()).join(", ");
      const tertiary = User.getDistricts(inv.getTertiaryLocations()).join(", ");
      return (
        <div key={idx} style={{ border: "1px solid #e0e0e0", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px", background: "#fff" }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Icon name="x" color="red" style={{ cursor: "pointer" }} onClick={() => this.onRemove(inv)} />
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
            <Image src={inv.getProfilePicURL()} avatar />
            <strong style={{ fontSize: "14px" }}>{inv.getName()}</strong>
          </div>
          <div style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>
            <Icon name="map marker alternate" size="small" />
            P: {primary} | S: {secondary} | T: {tertiary}
          </div>
          {it.serviceType && it.serviceType.length > 0 && (
            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: 600, fontSize: "12px", color: "#6b8a9e", marginBottom: "6px" }}>SERVICES</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {it.serviceType.map((s: string, i: number) => (
                  <span key={i} style={{ display: "inline-block", padding: "4px 12px", fontSize: "12px", border: "1px solid #b8d4e3", color: "#2185d0", borderRadius: "4px", background: "#eaf4fb", fontWeight: 500 }}>{s}</span>
                ))}
              </div>
            </div>
          )}
          {it.required_doc && it.required_doc.length > 0 && (
            <div>
              <div style={{ fontWeight: 600, fontSize: "12px", color: "#6b8a9e", marginBottom: "6px" }}>DOCUMENTS</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {it.required_doc.map((d: string, i: number) => (
                  <span key={i} style={{ display: "inline-block", padding: "4px 12px", fontSize: "12px", border: "1px solid #f0d9b5", color: "#c47a20", borderRadius: "4px", background: "#fdf3e7", fontWeight: 500 }}>{d}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      );
    });
    const investigationSpecsOptions = investigationSpecifications.map((it) => {
      return { text: it, value: it, key: it };
    });
    const caseState = this.props.model.getState();
    return (
      <>

        <div >
          <Accordion styled style={{ width: '100%' }}>
            <Accordion.Title
              active={this.state.isAccordionOpen}
              index={0}
              onClick={() =>
                this.setState((prevState) => ({
                  isAccordionOpen: !prevState.isAccordionOpen,
                }))
              }
            >
              <Header as="h4">
                <Icon name="dropdown" />
                Added Contacts
              </Header>
            </Accordion.Title>
            <Accordion.Content active={this.state.isAccordionOpen}>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Role In Case</Table.HeaderCell>
                    <Table.HeaderCell>Contact Number</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {this.state.contact.length ? (
                    this.state.contact
                      .slice()
                      .reverse()
                      .map((contact, index) => (
                        <Table.Row key={index}>
                          <Table.Cell>{contact.name}</Table.Cell>
                          <Table.Cell>{contact.role_in_case}</Table.Cell>
                          <Table.Cell>
                            <a
                              href="#"
                              style={{ color: "#0000FF" }}
                              onClick={(e) => {
                                e.preventDefault();
                                this.handleOpenConfirmModal(contact.contact_number as string);
                              }}
                            >
                              {contact.contact_number}
                            </a>
                          </Table.Cell>
                        </Table.Row>
                      ))
                  ) : (
                    <Table.Row>
                      <Table.Cell colSpan="3" style={{ textAlign: "center" }}>
                        No contacts added yet.
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>

              {/* Modals */}
              <Modal
                open={apiResponseModalOpen}
                onClose={() => this.setState({ apiResponseModalOpen: false })}
                size="small"
              >
                <Modal.Header>Please Make Sure To Remember This Pin For Calling</Modal.Header>
                <Modal.Content>
                  <p style={{ fontSize: "50px", textAlign: "center" }}>{apiResponseData}</p>
                </Modal.Content>
                <Modal
                  open={callItemModalOpen}
                  onClose={() => this.setState({ callItemModalOpen: false })}
                  size="small"
                >
                  <Modal.Actions>
                    <Button negative onClick={() => this.setState({ callItemModalOpen: false })}>
                      Cancel
                    </Button>
                    <Button positive>
                      Submit
                    </Button>
                  </Modal.Actions>
                </Modal>
                <Modal.Actions>
                  <Button
                    positive
                    onClick={() => {
                      this.setState({ apiResponseModalOpen: false }, () => {
                        this.setState({ callItemModalOpen: true });
                      });
                    }}
                  >
                    OK
                  </Button>
                </Modal.Actions>
              </Modal>
              <Modal
                open={this.state.confirmModalOpen}
                onClose={this.handleCloseConfirmModal}
                size="small"
              >
                <Modal.Header>Confirm Call</Modal.Header>
                <Modal.Content>
                  <p>Are you sure you want to call {this.state.selectedContactNumber}?</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button negative onClick={this.handleCloseConfirmModal}>
                    Cancel
                  </Button>
                  <Button positive onClick={this.handleConfirmCall}>
                    OK
                  </Button>
                </Modal.Actions>
              </Modal>
            </Accordion.Content>
          </Accordion>
        </div>
        <Modal open={this.state.modalOpen} onClose={this.handleCloseModal} size="small">
          <Modal open={this.state.confirmModalOpen}
            onClose={this.handleCloseConfirmModal}
            size="small"
          >
          </Modal>
          <Modal.Header>Add Contact</Modal.Header>
          <Modal.Content>
            <Form>
              <Form.Field>
                <label>Name</label>
                <Input
                    placeholder="StakeHolder Name"
                    value={this.state.name}
                    onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/[^a-zA-Z\s]/g, "");
                        value = value
                        .split(" ")
                        .map((word) =>
                            word.length > 0
                            ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                            : ""
                        )
                        .join(" ");
                        this.setState({ name: value });
                    }}
                  />
              </Form.Field>
              <Form.Field style={{ color: 'red' }}>
                <label>Role</label>
                <Dropdown
                  placeholder="Select Role"
                  fluid
                  search
                  selection
                  options={this.state.stakeholder_role}
                  value={role}
                  onChange={this.handleDropdownChange}
                />
              </Form.Field>

              <Form.Field>
                <label>Contact Number</label>
                <Input
                  placeholder="Contact Number"
                  maxLength={10}
                  pattern="[0-9]*"
                  value={this.state.contactNumber}
                  onChange={this.handleContactNumberChange}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button positive onClick={this.handleAddContact}>
              Add
            </Button>
          </Modal.Actions>
        </Modal>
        {
          (this.props.model.getState() === constants.caseStates.open || this.props.model.getState() === constants.caseStates.pushbackCA ||
          this.props.model.getState() === constants.caseStates.reinvestigate || this.props.model.getState() === constants.caseStates.generated ||  this.props.model.getState() === constants.caseStates.fold
           ||  this.props.model.getState() === constants.caseStates.checked || this.props.model.getState() === constants.caseStates.pushbackCA || this.props.model.getState() === constants.caseStates.pushbackRW ) &&
          <Accordion>
            <Accordion.Title active={this.state.active}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", alignItems: "center", padding: "4px 0" }}>
                <Button
                  primary
                  size="small"
                  disabled={
                    caseState !== constants.caseStates.generated &&
                    caseState !== constants.caseStates.open &&
                    caseState !== constants.caseStates.pushbackCA &&
                    caseState !== constants.caseStates.reinvestigate
                  }
                  onClick={() => this.setState({ active: !this.state.active })}
                >
                  <Icon name="dropdown" />
                  Allocate Investigator
                </Button>

                <Button
                  size="small"
                  onClick={this.handleOpenModal}
                  style={{ backgroundColor: "green", color: "white" }}
                >
                  <Icon name="add" />
                  Add Contact
                </Button>

                <Button size="small" icon style={{ backgroundColor: "#2185d0", color: "#fff" }} onClick={() => this.navigateIvrRecordings("recordings")}>
                  <Icon name="microphone" /> IVR Recordings
                </Button>

                {caseState === constants.caseStates.open && (
                  <Button
                    primary
                    size="small"
                    disabled={this.state.disableReportWriting}
                    onClick={this.handleReportWriting}
                  >
                    <Icon name="forward" />
                    Push For Report Writing
                  </Button>
                )}

                <Button
                  primary
                  size="small"
                  onClick={this.handleOpenApprovedExpenseModal}
                >
                  Expense Approved By Client
                </Button>

                <Button
                  size="small"
                  disabled={this.state.invoiceUrl.length === 0}
                  onClick={(e) =>
                    this.setState({
                      x: e.clientX,
                      y: e.clientY,
                      invoiceReceiptsVisible: true,
                    })
                  }
                  primary
                >
                  {this.state.invoiceUrl.length === 0 ? "No Invoice Receipts" : "View Invoice Receipts"}
                </Button>
              </div>
              {this.state.invoiceReceiptsVisible &&
                (document.getElementById("root") ? (
                  ReactDOM.createPortal(
                    <FilesPopup
                      x={this.state.x}
                      y={this.state.y}
                      onClose={() => this.setState({ invoiceReceiptsVisible: false })}
                      title="Invoice Receipts"
                      files={this.state.invoiceUrl}
                      allocationId={this.props.model.getId()}
                    />,
                    document.getElementById("root") as HTMLElement
                  )
                ) : (
                  <div>Root element not found!</div>
                ))}

            </Accordion.Title>
            <Accordion.Content active={this.state.active}>
              <Segment loading={this.state.loading} style={{ padding: "16px" }}>
                <Grid columns={2} stackable>
                  <Divider vertical>
                    <Icon name="arrow alternate circle right" />
                  </Divider>
                  <Grid.Row>
                    {/* investigator selection */}
                    <Grid.Column>
                      <Header as="h4" style={{ marginBottom: "6px" }}>
                        Step 1
                        <Header.Subheader style={{ fontSize: "12px", lineHeight: "1.4", marginTop: "3px" }}>
                          Select state and district in which you want to have an investigator on that location below. Selecting an investigator on the basis of state and district is optional.
                        </Header.Subheader>
                      </Header>
                      <Form>
                        <Form.Group widths="equal" style={{ marginBottom: "8px" }}>
                          <Form.Dropdown
                            search
                            selection
                            label="State"
                            loading={this.state.loadingStates}
                            value={this.state.selected_state}
                            onChange={(_, { value }) => {
                              this.setState({ selected_state: value as string })
                              this.getDistrict(value as string)
                            }}
                            options={this.state.stateOptions}
                            placeholder="State"
                          />
                          <Form.Dropdown
                            search
                            selection
                            label="District"
                            loading={this.state.loadingDistrict}
                            value={this.state.selected_district}
                            onChange={(_, { value }) => {
                              this.setState({ selected_district: value as string })
                              this.getInvestigators(this.state.selected_state, value as string)
                            }}
                            options={this.state.districtOptions}
                            placeholder="District"
                          />
                          <Form.Dropdown
                            search
                            selection
                            label="Investigator"
                            loading={this.state.loadingInvestigators}
                            value={this.state.alloc_selectedInvestigator}
                            onChange={(_, { value }) =>
                              this.setState({ alloc_selectedInvestigator: value as string })
                            }
                            options={this.state.investigatorOptions}
                            placeholder="Investigator"
                          />
                        </Form.Group>

                        {/* Services Block */}
                        <Segment style={{ padding: "10px 12px", marginBottom: "10px", marginTop: "6px" }}>
                          <label style={{ fontWeight: 600, fontSize: "13px", display: "block", marginBottom: "6px" }}>Services</label>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 18px" }}>
                            {this.state.servicesType.map((item, index) => (
                              <div key={index} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <input
                                  className="CaseTypeCheck"
                                  type="checkbox"
                                  id={item}
                                  value={item}
                                  checked={this.state.selectedServices.includes(item)}
                                  onChange={this.handleCheckboxChange}
                                  style={{ margin: 0, width: "15px", height: "15px" }}
                                />
                                <label htmlFor={item} style={{ fontSize: "13px", whiteSpace: "nowrap" }}>{item}</label>
                              </div>
                            ))}
                          </div>
                        </Segment>

                        {/* Required Documents Block */}
                        <Segment style={{ padding: "10px 12px", marginBottom: "10px", marginTop: "0" }}>
                          <label style={{ fontWeight: 600, fontSize: "13px", display: "block", marginBottom: "6px" }}>Required Documents</label>
                          {this.state.required_documents.length > 0 && (
                            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 18px", marginBottom: "8px" }}>
                              {this.state.required_documents.map((doc, index) => (
                                <div key={index} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                  <input
                                    type="checkbox"
                                    id={`doc-${index}`}
                                    value={doc}
                                    checked={this.state.selectedDocuments.includes(doc)}
                                    onChange={this.handleDocumentCheckboxChange}
                                    style={{ margin: 0, width: "15px", height: "15px" }}
                                  />
                                  <label htmlFor={`doc-${index}`} style={{ fontSize: "13px", whiteSpace: "nowrap" }}>{doc}</label>
                                </div>
                              ))}
                            </div>
                          )}
                          <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                            <input
                              type="text"
                              placeholder="Add document..."
                              value={this.state.customDocInput}
                              onChange={(e) => this.setState({ customDocInput: e.target.value })}
                              onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.handleAddCustomDocument(); } }}
                              style={{ padding: "6px 10px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "4px", flex: 1 }}
                            />
                            <Button size="mini" positive onClick={this.handleAddCustomDocument} type="button">Add</Button>
                          </div>
                        </Segment>

                        {/* Action Buttons Row */}
                        <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                          <Button
                            primary
                            icon
                            labelPosition="right"
                            onClick={() => {
                              this.setState({
                                alloc_selectedInvestigator: "",
                                selected_district: "",
                                selected_state: "",
                                districtOptions: [],
                                selectedServices: [],
                                services: [],
                                required_documents: this.state.originalRequiredDocuments || [],
                                selectedDocuments: [],
                                customDocInput: "",
                                alloc_selectedInvestigationSpecifications: [],
                                alloc_otherInvestigationSpecifications: "",
                              })
                              this.getInvestigators();
                            }}
                            disabled={
                              this.state.alloc_selectedInvestigator.length === 0 &&
                              this.state.selected_district.length === 0 &&
                              this.state.selected_state.length === 0 &&
                              this.state.selectedServices.length === 0 &&
                              this.state.selectedDocuments.length === 0
                            }
                          >
                            Clear
                            <Icon name="undo" />
                          </Button>
                          {(this.state.selectedDocuments.length > 0 || this.state.selectedServices.length > 0) && (
                            <Button
                              positive
                              icon
                              labelPosition="right"
                              onClick={this.onAdd}
                              disabled={this.state.alloc_selectedInvestigator.length === 0}
                            >
                              Add
                              <Icon name="arrow alternate circle right" />
                            </Button>
                          )}
                        </div>
                      </Form>
                    </Grid.Column>
                    {/* investigator selection */}

                    {/* allocation  */}
                    <Grid.Column>
                      <Header as="h4" style={{ marginBottom: "6px" }}>
                        Step 2
                        <Header.Subheader style={{ fontSize: "12px", lineHeight: "1.4", marginTop: "3px" }}>
                          Click on the Allocate Button to start Investigation.
                          Investigators will receive an email with Case Detail.
                        </Header.Subheader>
                      </Header>

                      <Header as="h5" style={{ marginBottom: "8px" }}>
                        Selected Investigators: {this.state.alloc_selection.length}
                      </Header>
                      <div>{selectionList}</div>
                      <Button
                        icon
                        positive
                        disabled={this.state.alloc_selection.length === 0}
                        labelPosition="right"
                        onClick={this.allocateInvesitgators}
                      >
                        Allocate Investigator{this.state.alloc_selection.length > 1 ? "s" : ""}
                        <Icon name="check circle" />
                      </Button>
                    </Grid.Column>
                    {/* allocation  */}
                  </Grid.Row>
                </Grid>
              </Segment>
            </Accordion.Content>
          </Accordion>


        }

        {/* Approved Expense */}
        <Modal
          open={this.state.approvedExpenseModalOpen}
          onClose={this.handleCloseApprovedExpenseModal}
          size="tiny"
        >
          <Modal.Header>Expense Approved By Client</Modal.Header>
          <Modal.Content>
            <Form onSubmit={this.handleSubmit}>
              <Form.Field>
                <label>Expense</label>
                <input
                  placeholder="Enter expense"
                  value={this.state.expenseTitle || ""}
                  onChange={(e) => this.setState({ expenseTitle: e.target.value })}
                />
              </Form.Field>

              <Form.Field>
                <label>Approval Letter</label>
                <input
                  type="file"
                  multiple
                  onChange={(e) => this.setState({ expenseFiles: e.target.files })}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button style={{ backgroundColor: "#db2828", color: "white" }} onClick={this.handleCloseApprovedExpenseModal}  >Cancel</Button>
            <Button
              style={{ backgroundColor: "#21ba45", color: "white" }}
              loading={this.state.loading}
              disabled={this.state.loading}
              onClick={this.handleApproveExpernce}
            >
              Submit
            </Button>
          </Modal.Actions>
        </Modal>
      </>
    );
  }
  private onAdd = () => {
    const id = this.state.alloc_selectedInvestigator;
    const investigator = this.findInvestigatorById(id);
    if (investigator === null) return;
    //remove investigator from options
    this.removeInvestigatorFromOptions(id);
    //get specs
    const specs = this.getSpecs();
    const serviceType = this.state.services
    const required_doc = this.state.selectedDocuments

    //add investigator to selection list
    this.addInvestigatorInSelectionList(investigator, specs, serviceType, required_doc);
    //clear the current selection
    this.setState({
      alloc_selectedInvestigator: "",
      alloc_selectedInvestigationSpecifications: [],
      alloc_otherInvestigationSpecifications: "",
      selected_district: "",
      selected_state: "",
      selectedServices: [],
      services: [],
      required_documents: this.state.originalRequiredDocuments || [],
      selectedDocuments: [],
      customDocInput: "",
    });
  };
  private removeInvestigatorFromOptions = (id: string) => {
    const options = this.state.investigatorOptions;
    const index = options.findIndex((it) => it.value === id);
    if (index === -1) return;
    options.splice(index, 1);
    this.setState({ investigatorOptions: [...options] });
  };
  private addInvestigatorInSelectionList = (
    investigator: User,
    specs: string[],
    serviceType: string[],
    required_doc: string[]
  ) => {
    const selection = this.state.alloc_selection;
    selection.push({ investigator, specs, serviceType, required_doc });
    this.setState({ alloc_selection: [...selection] });
  };
  private findInvestigatorById = (id: string) => {
    const index = this.state.investigators.findIndex((it) => it.getId() === id);
    if (index === -1) return null;
    return this.state.investigators[index];
  };
  private getSpecs = () => {
    const investigationSpecs = this.state.alloc_selectedInvestigationSpecifications;
    const services = this.state.services
    const required_doc = this.state.required_documents
    const otherSpecs = this.state.alloc_otherInvestigationSpecifications;

    let totalSpecs = [...investigationSpecs];
    if (this.state.alloc_otherInvestigationSpecifications.trim().length > 0) {
      totalSpecs = totalSpecs.concat(otherSpecs.split(","));
    }
    return totalSpecs;
  };
  private onRemove = (investigator: User) => {
    //remove investigator from selection list
    this.removeInvestigatorFromSelectionList(investigator);

    //add investigator back to list
    this.addInvestigatorInOptions(investigator);
  };
  private removeInvestigatorFromSelectionList = (investigator: User) => {
    const selection = this.state.alloc_selection;
    const index = selection.findIndex(
      (it) => it.investigator.getId() === investigator.getId()
    );
    if (index === -1) return;

    selection.splice(index, 1);
    this.setState({ alloc_selection: [...selection] });
  };
  private addInvestigatorInOptions = (investigator: User) => {
    const options = this.state.investigatorOptions;
    options.push(this.investigatorToDropDownOption(investigator));
    this.setState({ investigatorOptions: [...options] });
  };
  renderInvestigatorDropdownLabel = (model: User) => {

    const districts = User.getDistricts(model.getPrimaryLocations()).join();
    let colorCoding = "";
    let textColor = "";
    let fontSize = "";
    // #21ba45 rgb(50, 170, 90)
    if (model.getLevel()) {

      colorCoding = model.getLevel() === "primary" ? "#21ba45" :
        model.getLevel() === "secondary" ? "rgb(255, 232, 0)" :
          model.getLevel() === "tertiary" ? "rgb(215, 8, 0)" : "";
      if (colorCoding === "#21ba45" || colorCoding === "rgb(215, 8, 0)") {
        textColor = "#FFFFFF";
      }
      fontSize = colorCoding === "#21ba45" ? "16px" :
        colorCoding === "rgb(255, 232, 0)" ? "16px" :
          colorCoding === "rgb(215, 8, 0)" ? "16px" : fontSize;
    }
    return (
      <div style={{ display: "flex", backgroundColor: `${colorCoding}`, color: textColor, gap: "10px", padding: "8px 0px 8px 10px" }}>
        <Image src={model.getProfilePicURL()} avatar />
        <div style={{ margin: "0 4px" }}>
          <div style={{ fontSize: fontSize }}>{model.getName()}</div>
          <div style={{ fontSize: 12 }}>{districts}</div>
        </div>
      </div>
    );
  };


  private investigatorToDropDownOption = (investigator: User) => {
    // const style = investigator.style || "";
    return {
      key: investigator.getId(),
      value: investigator.getId(),
      text: investigator.getName(),
      content: this.renderInvestigatorDropdownLabel(investigator),
    };
  };;


  private renderStateDropDownLabel = (model: States) => {
    return (
      <div style={{ display: "flex", }}>
        <div style={{ margin: "0 4px" }}>
          <div>{model.getName()}</div>
        </div>
      </div>
    );
  }

  private stateToDropDownOption = (state: States) => {
    return {
      key: state.getId(),
      value: state.getName(),
      text: state.getName(),
      content: this.renderStateDropDownLabel(state)
    }
  }

  private renderDistrictDropDownLabel = (model: string) => {
    return (
      <div style={{ display: "flex", }}>
        <div style={{ margin: "0 4px" }}>
          <div>{model}</div>
        </div>
      </div>
    );
  }

  private districtToDropDownOption = (district: string) => {
    return {
      key: district,
      value: district,
      text: district,
      content: this.renderDistrictDropDownLabel(district)
    }
  }
}



export default (props: any) => {
  return (
    <RequirePermission permission={permissions.Case.allocate}>
      <ActionAllocation {...props} />
    </RequirePermission>
  );
};

